(() => {
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const dialog = gallery.querySelector('[data-gallery-zoom]');
    const image = dialog?.querySelector('[data-zoom-image]');
    const counter = dialog?.querySelector('[data-zoom-count]');
    if (!dialog || !image || !slides.length || !dialog.showModal) return;
    let current = 0;
    let origin = null;
    const render = index => {
      current = (index + slides.length) % slides.length;
      const source = slides[current].querySelector('img');
      image.src = slides[current].href;
      image.alt = source?.alt || '';
      counter.textContent = `${current + 1} / ${slides.length}`;
    };
    slides.forEach((slide, index) => slide.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      origin = slide;
      render(index);
      dialog.showModal();
    }));
    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.querySelectorAll('[data-zoom-step]').forEach(button => button.addEventListener('click', () => render(current + Number(button.dataset.zoomStep))));
    dialog.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      render(current + (event.key === 'ArrowLeft' ? -1 : 1));
    });
    dialog.addEventListener('close', () => origin?.focus({ preventScroll: true }));
  });
})();
